module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "copyright pull-center"
  }, [_vm._v("\n      © 2019 by the "), _c('a', {
    attrs: {
      "href": "http://ocds.co",
      "target": "_blank"
    }
  }, [_vm._v("Optima Nutrition Working Group")]), _vm._v(". "), _c('a', {
    attrs: {
      "href": "http://ocds.co/home/legal.html",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t("footer.Terms and conditions")))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4476b845","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/ContentFooter.vue
// module id = 376
// module chunks = 1